export const Light = {
  backgroundProperty: `background: #ebfefe;`,
  colors: {
    primary: "#222244",
    secondary: "#438FB2",
    accent: "#cc9161",
  },
}
